module.exports = __webpack_public_path__ + "img/car-icon.7a3b8df4.svg";